import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

export default function PageHeader(props) {
  const history = useHistory();
  return (
    <div className="page-header">
      <h3 className="page-title"> {props.titulo} </h3>
      <nav aria-label="breadcrumb">
        {props.hasButton && (
          <button
            onClick={() => history.push(props.pageName)}
            className="btn btn-primary"
          >
            {props.buttonText}
          </button>
        )}
      </nav>
    </div>
  );
}

PageHeader.propTypes = {
  titulo: PropTypes.string,
  hasButton: PropTypes.bool,
  buttonText: PropTypes.string,
  pageName: PropTypes.string,
};
